export default __webpack_public_path__ + "static/microsoft-official-partner-5b60d5117411295a0200dbefa93df25b.png";